import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      width: 600,
      height: 660,
    },
    title: (props) => ({
      paddingTop: 36,
      paddingBottom: 24,
      paddingLeft: 0,
      paddingRight: 0,
      textAlign: "center",
      fontSize: 34,
      fontFamily: "Mulish",
      letterSpacing: 0.25,
      width: props.isMobile ? "auto" : 600,
    }),
    divider: {
      height: 1,
      backgroundColor: theme.palette.grey[300],
      margin: "0px 24px",
    },
    requestData: (props) => ({
      display: "flex",
      flexDirection: props.isMobile ? "column" : "row",
      justifyContent: "flex-start",
      paddingTop: 40,
      paddingBottom: 24,
    }),
    messageContainer: {
      backgroundColor: theme.palette.grey[300],
      padding: 24,
      borderRadius: 8,
    },
    iconSend: {
      width: "22px",
      height: "22px",
      color: theme.palette.grey[600],
    },
    initialMessage: {
      backgroundColor: theme.palette.grey[600],
      color: "white",
      fontFamily: "Mulish",
      padding: "15px 11px 13px 11px",
      borderRadius: 4,
      marginTop: 20,
      marginBottom: 24,
    },
    initialMessageLoading: {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[300],
      fontFamily: "Mulish",
      padding: "15px 11px 13px 11px",
      borderRadius: 4,
      marginTop: 20,
      marginBottom: 24,
    },
    textInput: {
      "& .MuiOutlinedInput-input": {
        padding: 14,
      },
    },
    editItemContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      border: `1px solid ${theme.palette.grey[600]}`,
      borderRadius: "50%",
      width: 36,
      height: 36,
      marginLeft: 4,
      cursor: "pointer",
    },
    editItemContainerLoading: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.palette.grey[300],
      borderRadius: "50%",
      width: 36,
      height: 36,
      marginLeft: 4,
      cursor: "pointer",
    },
    editItemIcon: {
      width: 20,
      height: 20,
      alignItems: "center",
      color: theme.palette.grey[600],
    },
    editItemIconLoading: {
      width: 20,
      height: 20,
      alignItems: "center",
      color: theme.palette.grey[300],
    },
    arrowContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "0px 4px",
    },
    leaveTypeContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "flex-start",
      paddingLeft: 20,
      marginTop: "-4px",
      fontFamily: "Mulish",
    },
    leaveTypeText: {
      fontSize: 16,
      letterSpacing: 0.44,
    },
    leaveTypeTextLoading: {
      fontSize: 16,
      letterSpacing: 0.44,
      color: theme.palette.grey[300],
      backgroundColor: theme.palette.grey[300],
      width: 88,
      height: 20,
    },
    workDaysText: {
      display: "inline-block",
      fontSize: 14,
      letterSpacing: 0.25,
      minWidth: 100,
    },
    workDaysTextLoading: {
      display: "inline-block",
      fontSize: 14,
      letterSpacing: 0.25,
      width: 100,
      color: theme.palette.grey[300],
      backgroundColor: theme.palette.grey[300],
      height: 18,
    },
    rightContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      paddingTop: 0,
    },
    stateContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    createdAtText: {
      fontFamily: "Mulish",
      fontSize: 10,
      paddingBottom: 2,
      color: theme.palette.grey[600],
      textAlign: "center",
      textTransform: "capitalize",
    },
    createdAtTextLoading: {
      fontFamily: "Mulish",
      fontSize: 10,
      paddingBottom: 2,
      textAlign: "center",
      textTransform: "capitalize",
      color: theme.palette.grey[300],
      backgroundColor: theme.palette.grey[300],
      height: 13,
      marginBottom: 2,
    },
    editIconContainer: {
      paddingTop: 10,
      marginLeft: 36,
      width: 42,
    },
  })
);

export default useStyles;
